module.exports = __webpack_public_path__ + "img/logo2.8ebb65b9.png";